<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog">
        <el-form ref="formValidate" :model="model" label-width="120px">
            <el-form-item label="关键字：" prop="title">
                <span>{{model.title}}</span>
            </el-form-item>
            <el-form-item label="排序：" prop="order_index">
                <span>{{model.order_index}}</span>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeDialog" size="medium">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'goodsSearchLogInfo',
    mixins: [editutil],
    data() {
        return {
            model: {
                title: '',
                order_index: '',
            },
            getObj:{
                url:'/api/admin/goodssearchlog/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
        };
    },
    methods: {}
};
</script>